import { PureComponent } from "react";
import CardComponent from "./card/card-component";
import FactDetailsComponent from "./fact-details/fact-details-component";
import FactQuoteComponent from "./fact-quote/fact-quote-component";
import { StyledFactCardComponent } from "./fact-card-component.scss";

export default class FactCardComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { width, height, detailsCard, quoteCard } = this.props;
    const detailsCardBackground = detailsCard.background;
    const quoteCardBackground = quoteCard.background;

    return (
      <StyledFactCardComponent className="fact-card-component">
        <div className="fact-details-wrapper">
          <CardComponent width={width} height={height} background={detailsCardBackground}>
            <FactDetailsComponent {...detailsCard} />
          </CardComponent>
        </div>

        <div className="fact-quote-wrapper">
          <CardComponent width={width} height={height} background={quoteCardBackground}>
            <FactQuoteComponent {...quoteCard} />
          </CardComponent>
        </div>
      </StyledFactCardComponent>
    );
  }
}

FactCardComponent.defaultProps = {
  detailsCard: {},
  quoteCard: {}
};
